<div class="dropdown" dropdown>
  <button [id]="buttonId" class="btn dropdown-toggle" [ngClass]="getClass()" dropdownToggle type="button" [attr.aria-controls]="menuId" role="button">
    <span>{{resolveName(selectedItem)}}</span>
    <fa-icon [icon]="['fas', 'chevron-down']"></fa-icon>
  </button>
  <ul class="dropdown-menu w-100" *dropdownMenu [id]="menuId" role="menu" khA11yLabel [a11yLabelledBy]="buttonId">
    <li *ngFor="let item of items" role="menuitem" class="dropdown-item cursor-pointer text-truncate" (click)="onItemClick(item)" data-testid="dropdown-item">
      {{resolveName(item)}}
    </li>
  </ul>
</div>
